const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const storageKey = 'bsa-campaign';
export function captureAttribution(): Record<string, string> {
  const search = new URLSearchParams(window.location.search);
  const current = Object.fromEntries(keys.filter(key => search.has(key)).map(key => [key, (search.get(key) || '').slice(0, 200)]));
  try {
    if (Object.keys(current).length) { sessionStorage.setItem(storageKey, JSON.stringify(current)); return current; }
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    return Object.fromEntries(keys.filter(key => typeof saved[key] === 'string').map(key => [key, saved[key].slice(0, 200)]));
  } catch { return current; }
}
